// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,  
  apiRoot: 'https://backend.governancetoolkit365.com',
  clientId: '00ae3a43-e71e-4401-8106-f601290a21bc',
  gtRoot: 'https://governancetoolkit365.azurewebsites.net/api/StartSyncSingle/[tenantId]?code=kM-BJfA4HxZZHjMqUvIUWVbZ67WhDioSb7-F-COtrgGTAzFun5R1YQ=='
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
